<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <app-contentpopup [contentPopups]="contentPopups" [content_value]="content_value" [contentKey]="contentKey"
        [contentTableArray]="contentTableArray" [content_Details]="content_Details"
        (closecontentpopup)="closecontentpopup()" [tablevalues]="tablevalues" [tablekeys]="tablekeys">
    </app-contentpopup>
    <!-- <app-popup [displaypopup]="displaypopup" [nullmessage]="nullmessage" [popupcontents]="popupcontents"
    (closepopup)="popupfunc($event)"></app-popup> -->
    <!-- Header Block -->
    <div class="container-fluid">
        <div class="container-fluid my-3">
            <div class="top-card">
                <div class="row w-100 mx-auto d-flex  ">
                    <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
                        <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
                        <span class="">Portfolio Management Suite</span>
                    </div>
                </div>
            </div>
        </div>

        <p style="font-weight: bold;">Total Count :- {{total_count}}</p>

        <div class="card" style="margin: 10px;border-radius: 10px;">

            <div class="">
                <div class="row">
                    <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
                        <p class="my-auto ml-3" style="font-size: 20px;font-weight: 600;">Enter The Molecule</p>
                    </div>

                    <div class="col-5 col-md-5 col-sm-12" style="margin: 10px;">
                        <i class="fa fa-search icon" style="margin-right: 10px;"></i>
                        <input class="w-75" placeholder="Enter the Molecule Name" [(ngModel)]="searchValue"
                            (keydown.enter)="searchMolecule()" autofocus>
                    </div>

                    <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
                        <button type="button" class="btn btn-light" (click)="searchMolecule()">Submit</button>
                    </div>

                    <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
                        <p-dropdown [options]="submolecules" [(ngModel)]="selectedSubMolecule" autoWidth="false"
                            [style]="{'width':'90%','font-size':'12px'}" optionLabel="name" placeholder="Select NDA"
                            (click)="getData()" *ngIf="subMolecule">
                        </p-dropdown>
                    </div>

                    <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
                        <button type="button" class="btn btn-light" (click)="clearFilter()">Clear</button>
                    </div>

                </div>
            </div>

        </div>

        <!-- <button (click)="download()">Download</button>
    <input type="file" (change)="HandleInput($event)"/> -->

        <div class="container-fluid" *ngIf="Molecule">
            <p-toast [style]="{ marginTop: '80px' }"></p-toast>
            <div class="tab-execsum">
                <!-- PRODUCT DETAILS -->
                <div>
                    <p-accordion expandIcon="pi pi-chevron-circle-down" [multiple]="true"
                        collapseIcon="pi pi-chevron-circle-up"
                        *ngIf="page_access.RetrieveInnovatorBrandProductDetails && page_access.RetrieveInnovatorBrandProductDetails === true">
                        <p-accordionTab header="INNOVATOR/BRAND PRODUCT DETAILS" [selected]="true">
                            <table class="table table-bordered" id="excel-table">
                                <div class="table-responsive">
                                    <thead *ngIf="!this.paramsValues.section">
                                        <tr>
                                            <th *ngIf="showCheckBox" style="text-align: center;">Select</th>
                                            <th></th>
                                            <th>
                                                <i class="fa fa-edit icons" (click)="editbtn()"></i>
                                                <i class="fa fa-download icons" title="Dowload file"
                                                    (click)="downloadFiles()"></i>
                                                <i class="fa fa-check-square icons" title="Download upon selection"
                                                    (click)="downloadSelected()"></i>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr *ngFor="let Obj of DragData | Object2keyvalue; let index=index"
                                            [ngStyle]="{'display': Obj.key ==='colorindicator' ?'none' : ' ' }">
                                            <td *ngIf="showCheckBox"><input type="checkbox" style="margin-left: 2.5rem;"
                                                    (click)="selected_checbox(Obj.key, index)" /></td>
                                            <td #headerids
                                                [ngStyle]="{'display': Obj.key ==='colorindicator' ?'none' : ' ' }"
                                                [ngClass]="[getcolorcode(Obj.key,DragData.colorindicator), Obj.key === 'Dosage and Administration' || Obj.key === 'Recommended dose' || Obj.key === 'Food effect' || Obj.key === 'Indications and Usage'||Obj.key === 'Variability (% ISCV)'||Obj.key === 'PK Linearity'|| Obj.key === 'Pharmacology'? 'underline': '']">
                                                {{Obj.key}}
                                            </td>
                                            <td>
                                                <div *ngIf="Obj.value | arrayChk;else displayvalue;let is=index">
                                                    <div *ngIf="Obj.value | tableChk;else list">
                                                        <div class="table-responsive">
                                                            <table class="table table-bordered" id="innertable">
                                                                <thead style="font-size: 12px;">
                                                                    <tr>
                                                                        <th *ngFor="let headers of Obj.value | tableHeaders"
                                                                            id="innertableheader">
                                                                            <p>{{headers}}</p>
                                                                            <!-- <p [ngClass]="[showedit?'editcls':'editdisable']" ><input type="text" (change)="editdata($event,Obj.value,Obj.key)" class="p1" value={{headers}}/></p> -->
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody style="font-size: 10px;">
                                                                    <tr
                                                                        *ngFor="let trows of Obj.value | tableBody | slice:0:sliceEnd;let m=index">
                                                                        <td
                                                                            *ngFor="let rdata of trows;let iindex =index">
                                                                            <p
                                                                                [ngClass]="[showedit?'editcls':'editdisable']">
                                                                                <input type="text"
                                                                                    (change)="editdata($event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)"
                                                                                    [ngClass]="[rdata.length>=20?'input-size':'']"
                                                                                    value={{rdata}} id={{rdata}} />
                                                                            </p>
                                                                            <p
                                                                                [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']">
                                                                                {{Obj.key === 'Dosage and
                                                                                Administration' || Obj.key ===
                                                                                'Recommended dose' || Obj.key === 'Food
                                                                                effect' || Obj.key === 'Indications and
                                                                                Usage' ||Obj.key === 'Variability (%
                                                                                ISCV)'||Obj.key === 'PK
                                                                                Linearity'||Obj.key === 'Pharmacology'?
                                                                                '': rdata}}
                                                                            </p>
                                                                        </td>
                                                                    </tr>

                                                                    <i [ngClass]="[showedit?'editcls':'editdisable']"
                                                                        style="font-size: 20px;"
                                                                        class="fas fa-plus float-left"
                                                                        (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)"></i>
                                                                    <button
                                                                        [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                                                                        *ngIf="Obj.value.length>sliceEnd"
                                                                        class="btn btn-success"
                                                                        (click)="showLess(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show
                                                                        More</button>

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <ng-template #list>
                                                        <ul>

                                                            <li *ngFor="let lItems of Obj.value | slice:0:sliceEnd;let inds=index"
                                                                [ngClass]="[Obj.key === 'Dosage and Administration' || Obj.key === 'Recommended dose' || Obj.key === 'Food effect' || Obj.key === 'Indications and Usage'||Obj.key === 'Variability (% ISCV)'||Obj.key === 'PK Linearity'||Obj.key ==='Pharmacology'?'list-style-none ':'list-style-type']">
                                                                <p [ngClass]="[showedit?'editcls':'editdisable']">
                                                                    <!-- <input type="text" [ngClass]="[lItems.length>=20?'input-size':'']" (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')" value={{lItems}} /> -->
                                                                    <textarea
                                                                        [ngClass]="[lItems.length>=20?'input-size':'']"
                                                                        (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')"
                                                                        style="height: 30px;" value={{lItems}} cols="30"
                                                                        rows="10"></textarea>
                                                                </p>
                                                                <p [ngClass]="[!showedit?'editcls':'editdisable']">

                                                                    {{Obj.key === 'Dosage and Administration' || Obj.key
                                                                    === 'Recommended dose' || Obj.key === 'Food effect'
                                                                    || Obj.key === 'Indications and Usage'||Obj.key ===
                                                                    'Variability (% ISCV)'||Obj.key === 'PK Linearity'
                                                                    || Obj.key === 'Pharmacology'? '': lItems}}

                                                                </p>

                                                            </li>
                                                            <i [ngClass]="[showedit?'editcls':'editdisable']"
                                                                style="font-size: 20px;" class="fas fa-plus float-left"
                                                                (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key)"></i>
                                                            <button
                                                                [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                                                                *ngIf="Obj.key !== 'Dosage and Administration' && Obj.key !== 'Recommended dose' &&  Obj.key !== 'Indications and Usage' && Obj.value.length>5"
                                                                class="btn btn-success"
                                                                (click)="showArray(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show
                                                                More</button>

                                                        </ul>
                                                    </ng-template>
                                                </div>
                                                <ng-template #displayvalue>
                                                    <p
                                                        [ngClass]="[showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                                                        <input type="text"
                                                            [ngClass]="[Obj.value?.length>=20?'input-size':'']"
                                                            value={{Obj.value}}
                                                            (change)="editdata($event,Obj.value,Obj.key,index,'')" />
                                                    </p>
                                                    <p [ngClass]="[!showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']"
                                                        (click)="addClickEvent($event,Obj.value,Obj.key)">
                                                        {{Obj.key === 'Dosage and Administration' || Obj.key ===
                                                        'Recommended dose' || Obj.key === 'Food effect' || Obj.key ===
                                                        'Indications and Usage'||Obj.key === 'Variability (%
                                                        ISCV)'||Obj.key === 'PK Linearity' ||Obj.key === 'Pharmacology'
                                                        ? '': Obj.value}}

                                                    </p>

                                                    <i [ngClass]="[ Obj.key ==='FDA label' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                                                        (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o"
                                                        style="font-size: 30px;"></i>
                                                    <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                                                        (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o"
                                                        style="font-size: 30px;"></i>
                                                    <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div>
                                                    <div
                                                        *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">
                                                        N/A</div>
                                                </ng-template>

                                                <div *ngFor="let edited of isChanged(Obj.key)">
                                                    <div *ngIf="edited === Obj.key" [id]="Obj.key">
                                                        <i class="fa fa-check" title="Accept"
                                                            (click)="handelAction(Obj,'accept')"
                                                            style="cursor: pointer;color:#2bc44e;padding-left:1rem;"></i>
                                                        <i class="fa fa-remove" title="Reject"
                                                            (click)="handelAction(Obj,'reject')"
                                                            style="cursor: pointer;padding-left:3rem;color:red"></i>
                                                    </div>
                                                </div>

                                            </td>

                                        </tr>
                                        <tr>
                                            <td *ngIf="showCheckBox">
                                                <button class="btn btn-primary"
                                                    (click)="downloadSelectedData()">Download</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </div>
                            </table>
                            <div *ngIf="showedit" class="text-center">
                                <button class="btn btn-primary" (click)="saveEdit()">Save</button>
                            </div>
                        </p-accordionTab>

                        <!-- SECOND SECTION -- PATENT INFORMATION -->
                        <p-accordionTab header="PATENT INFORMATION"
                            *ngIf="page_access.PatentInformation && page_access.PatentInformation === true">
                            <p-toast [style]="{ marginTop: '80px' }"></p-toast>
                            <life-patent-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                                [NDAnumber]="ndaforPI"></life-patent-info>
                        </p-accordionTab>

                        <!-- THIRD SECTION --REGULATORY INFORMATION -->
                        <p-accordionTab header="REGULATORY INFORMATION"
                            *ngIf="page_access.RegulatoryInformation && page_access.RegulatoryInformation === true">
                            <p-toast [style]="{ marginTop: '80px' }"></p-toast>
                            <life-regulatory-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                                [NDAnumber]="ndaforPI"></life-regulatory-info>
                        </p-accordionTab>

                        <!-- FOURTH SECTION -- -->
                        <p-accordionTab header="CLINICAL INFORMATION"
                            *ngIf="page_access.ClinicalInformation && page_access.ClinicalInformation === true">
                            <p-toast [style]="{ marginTop: '80px' }"></p-toast>
                            <life-clinical-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                                [NDAnumber]="ndaforPI"></life-clinical-info>
                        </p-accordionTab>

                        <!-- FIFTH SECTION -->
                        <p-accordionTab header="API INFORMATION"
                            *ngIf="page_access.APIInformation && page_access.APIInformation === true">
                            <p-toast [style]="{ marginTop: '80px' }"></p-toast>
                            <life-api-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                                [NDAnumber]="ndaforPI"></life-api-info>
                        </p-accordionTab>

                        <!-- SIXTH SECTION -->
                        <p-accordionTab header="FORMULATION INFORMATION"
                            *ngIf="page_access.FormulationInformation && page_access.FormulationInformation === true">
                            <p-toast [style]="{ marginTop: '80px' }"></p-toast>
                            <life-formulation-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                                [NDAnumber]="ndaforPI"></life-formulation-info>
                        </p-accordionTab>

                        <!-- SEVENTH SECTION -->
                        <p-accordionTab header="COMPETITIVE INTELLIGENCE"
                            *ngIf="page_access.CompetitiveIntelligence && page_access.CompetitiveIntelligence === true">
                            <p-toast [style]="{ marginTop: '80px' }"></p-toast>
                            <life-competitiveintellegence [ActiveIngred]="activeIngredientforPI"
                                [BrandName]="brandNameforPI" [NDAnumber]="ndaforPI"></life-competitiveintellegence>
                        </p-accordionTab>

                        <!-- EIGHT SECTION -->
                        <p-accordionTab header="EXECUTIVE SUMMARY"
                            *ngIf="page_access.ExecutiveSummary && page_access.ExecutiveSummary === true">
                            <p-toast [style]="{ marginTop: '80px' }"></p-toast>
                            <life-executive-summary [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                                [NDAnumber]="ndaforPI"></life-executive-summary>
                        </p-accordionTab>

                        <!-- NINTHSECTION -->
                        <p-accordionTab header="COSTING RELATED AND DETAILS"
                            *ngIf="page_access.CostingRelatedOthers && page_access.CostingRelatedOthers === true">
                            <p-toast [style]="{ marginTop: '80px' }"></p-toast>
                            <life-costing-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                                [NDAnumber]="ndaforPI"></life-costing-info>
                        </p-accordionTab>
                    </p-accordion>

                </div>
            </div>
        </div>
        <div class="nodata" *ngIf="noData">
            <p> No Data Found</p>
        </div>
    </div>
</div>